var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthenticationRepository } from 'packages/authentication/AuthenticationRepository';
import ENV from 'config/env';
import { container, singleton } from 'tsyringe';
import jwt from 'jws';
import axios from 'axios';
import Vue from 'vue';
import Cookies from 'js-cookie';
import posthog from 'posthog-js';
export var ACCESS_TOKEN_COOKIE_NAME = 'auth.access-token';
export var REFRESH_TOKEN_COOKIE_NAME = 'auth.refresh-token';
/*
 * With the simple hostname manipulation, we will choose the correct cookie domain implicitly.
 *
 * If the app runs at `*.tas.qa.jobilla.guru`, cookie domain becomes `qa.jobilla.guru`,
 * If the app runs at `ats.app.staging.jobilla.com`, cookie domain becomes `app.staging.jobilla.com`,
 * If the app runs at `tas.app.jobilla.com`, cookie domain becomes `app.jobilla.com`,
 * If the app runs at `localhost`, cookie domain becomes `localhost`.
 */
export var TOKEN_COOKIE_DOMAIN = window.location.hostname.endsWith('qa.jobilla.guru')
    ? '.qa.jobilla.guru'
    : window.location.hostname.replace(/^tas/, '');
export var SELECTED_COMPANY = 'JobillaCompany';
var Authenticator = /** @class */ (function () {
    function Authenticator() {
        this.repo = container.resolve(AuthenticationRepository);
        this.decodedTokenObject = null;
        this.permissionData = Vue.observable({
            companies: [],
            groups: [],
            objects: [],
            unitRoles: {},
        });
    }
    Object.defineProperty(Authenticator.prototype, "currentUserId", {
        get: function () {
            if (!this.decodedToken) {
                return;
            }
            return this.decodedToken.sub || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authenticator.prototype, "decodedToken", {
        get: function () {
            var _a;
            if (!this.decodedTokenObject) {
                var token = this.getToken();
                this.decodedTokenObject = token ? (_a = jwt.decode(token)) === null || _a === void 0 ? void 0 : _a.payload : null;
            }
            return this.decodedTokenObject;
        },
        enumerable: false,
        configurable: true
    });
    Authenticator.prototype.getToken = function () {
        var token = Cookies.get(ACCESS_TOKEN_COOKIE_NAME);
        if (['undefined', 'null', null].includes(token)) {
            return null;
        }
        return token;
    };
    Authenticator.prototype.getRefreshToken = function () {
        var _a;
        return (_a = Cookies.get(REFRESH_TOKEN_COOKIE_NAME)) !== null && _a !== void 0 ? _a : null;
    };
    Authenticator.prototype.getCompaniesIds = function () {
        return this.permissionData.companies;
    };
    Authenticator.prototype.fetchPermissions = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, objects, companies, units;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.repo.getPermissions()];
                    case 1:
                        _a = _b.sent(), objects = _a.objects, companies = _a.companies, units = _a.units;
                        this.permissionData.companies = Object.keys(companies).map(function (id) { return +id; });
                        this.permissionData.groups = companies[this.getSelectedCompany()];
                        this.permissionData.objects = objects;
                        this.permissionData.unitRoles = units;
                        return [2 /*return*/];
                }
            });
        });
    };
    // Used for getting the companyId set by the token once on login
    Authenticator.prototype.getSelectedCompany = function () {
        var localStorageCompanyId = localStorage.getItem(SELECTED_COMPANY);
        if (localStorageCompanyId && Number.isFinite(+localStorageCompanyId)) {
            return +localStorageCompanyId;
        }
        if (this.permissionData.companies.length > 0) {
            return this.permissionData.companies[0];
        }
        return null;
    };
    Authenticator.prototype.setToken = function (token) {
        // Clear previous decoded token if exists
        this.decodedTokenObject = null;
        Cookies.set(ACCESS_TOKEN_COOKIE_NAME, token, {
            domain: TOKEN_COOKIE_DOMAIN,
            secure: true,
        });
        this.selectCompanyFromToken(token);
        // Make sure Authorization header initialized at JobillaSpaApplication is refreshed with token
        axios.defaults.headers.common.Authorization = "Bearer " + this.getToken();
    };
    Authenticator.prototype.setRefreshToken = function (refreshToken) {
        Cookies.set(REFRESH_TOKEN_COOKIE_NAME, refreshToken, {
            domain: TOKEN_COOKIE_DOMAIN,
            secure: true,
        });
    };
    Authenticator.prototype.selectCompany = function (id) {
        localStorage.setItem(SELECTED_COMPANY, id);
    };
    Authenticator.prototype.selectCompanyFromToken = function (token) {
        if (!token) {
            return;
        }
        var decodedToken = jwt.decode(token).payload;
        if (decodedToken && decodedToken.company_id) {
            this.selectCompany(decodedToken.company_id);
        }
    };
    Authenticator.prototype.updateAuthVariables = function (token, companyId) {
        if (token) {
            try {
                this.setToken(token);
            }
            catch (err) {
                return this.logOut();
            }
        }
        if (companyId) {
            this.selectCompany(companyId);
        }
    };
    Authenticator.prototype.check = function () {
        return this.repo.checkAuthState();
    };
    Authenticator.prototype.logIn = function (email, password, token, provider) {
        return __awaiter(this, void 0, Promise, function () {
            var result, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(provider && token)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.repo.loginSocial(email, token, provider)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.repo.login(email, password)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        result = _a;
                        this.setToken(result.access_token);
                        this.setRefreshToken(result.refresh_token);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Authenticator.prototype.refreshToken = function () {
        return __awaiter(this, void 0, Promise, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // If there is no refresh token, we can't refresh the token, so it must be a full re-login.
                        if (!this.getRefreshToken()) {
                            return [2 /*return*/, this.logOut(true)];
                        }
                        return [4 /*yield*/, this.repo.refresh(this.getRefreshToken())];
                    case 1:
                        result = _a.sent();
                        this.setToken(result.access_token);
                        this.setRefreshToken(result.refresh_token);
                        return [2 /*return*/];
                }
            });
        });
    };
    Authenticator.prototype.logOut = function (redirect) {
        if (redirect === void 0) { redirect = false; }
        return __awaiter(this, void 0, Promise, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, this.repo.logOut()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3:
                        Cookies.remove(ACCESS_TOKEN_COOKIE_NAME);
                        posthog.reset();
                        return [7 /*endfinally*/];
                    case 4:
                        if (redirect) {
                            this.redirectToLogin();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Authenticator.prototype.requestPasswordReset = function (email) {
        return this.repo.requestReset(email);
    };
    Authenticator.prototype.isRedirectDestinationAllowed = function (url) {
        var allowedDomains = ['jobilla.com', 'jobilla.guru', 'jobilla.dev', 'jobilla-admin.netlify.app'];
        if ((url === null || url === void 0 ? void 0 : url.hostname) === 'localhost') {
            return true;
        }
        if (!url.hostname || url.protocol !== 'https:') {
            return false;
        }
        return allowedDomains.some(function (domain) {
            // We want to make sure the hostname ends with an allowed root domain, that's why $
            var regex = domain + "$";
            if (url.hostname.match(regex)) {
                return true;
            }
        });
    };
    Authenticator.prototype.redirectToLogin = function () {
        window.location.replace(ENV.LOGIN_URL + "?redirect=" + encodeURIComponent(window.location.href));
    };
    Authenticator = __decorate([
        singleton()
    ], Authenticator);
    return Authenticator;
}());
export { Authenticator };
